import React, {useEffect} from 'react';
import { MapContainer, TileLayer, WMSTileLayer, useMapEvents, useMap, Polygon } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

const MapViewer = ({ mapKey, layer, data, center, setCenter, zoom, setZoom, setMap, geom, geoserverUrl }) => {

  const MapEvents = () => {
    const map = useMapEvents({
      zoomend: () => {
        setZoom(map.getZoom());
        setCenter(map.getCenter())
      },
      moveend: () => {
        setCenter(map.getCenter());
      }
    });

    return null;
  };

  const Map = () =>
    {
      const map = useMap()
      useEffect( () => {
        setMap(map)
    }, [map])
    return null;           
    }

    const swapCoordinates = (coordinates) => {
      return coordinates.map(polygon =>
        polygon.map(ring =>
          ring.map(coordinate => [coordinate[1], coordinate[0]])
        )
      );
    };

  return (
    <MapContainer key={mapKey} center={center} zoom={zoom} style={{ height: '100%', width: '100%' }}>
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />    
      <WMSTileLayer
        url={geoserverUrl}
        layers={layer}
        format="image/png"
        transparent={true}
        attribution="&copy; GeoServer"
        styles={data.style}
      />
      <WMSTileLayer
        url={geoserverUrl}
        layers={layer}
        format="image/png"
        transparent={true}
        attribution="&copy; GeoServer"
        styles="cantones"
      />   
      <WMSTileLayer
        url={geoserverUrl}
        layers="limites_provinciales"
        format="image/png"
        transparent={true}
        attribution="&copy; GeoServer"
        styles="Mapa1_Provincias"
      />
      <Polygon
        positions={Array.isArray(geom) ? swapCoordinates(geom) : [] }
        pathOptions={{
          color: '#C62828',
          fill: false,
        }}
      />
      <MapEvents />
      <Map />
    </MapContainer>
  );
};

export default MapViewer;
